/**
 * 客戶計費類型（cis.customer_type）與「該不該讓客戶選付款方式」的判斷。
 *
 * 後端 deriveBillingMethod 把客戶分成三種計費方式：
 *   月結客戶            → month_end_settlement（併入月底帳單）
 *   三種瓦斯表／發報器  → device_metered（依抄表度數結算）
 *   其餘                → cash（貨到付款）
 *
 * 前兩種在下單當下金額都還沒定案，不該走線上收款。後端 submit 也會擋
 * （BILLING_METHOD_NOT_ONLINE_PAYABLE），這裡是體驗層：不讓他們看到選不得的東西。
 */

/** 與後端 CustomerTypeEnum.month_end_settlement 對齊 */
export const MONTHLY_CUSTOMER_TYPE = "月結客戶";

/**
 * 依抄表度數結算的客戶類型。
 * 與後端 deriveBillingMethod 的 device_metered 分支一字不差
 * （CustomerTypeEnum 的 normal_device / iot_device / iot_transmitter）。
 */
export const METERED_CUSTOMER_TYPES = ["一般瓦斯表客戶", "物聯網瓦斯表客戶", "物聯網發報器客戶"] as const;

export const isMonthlyCustomerType = (customerType?: string | null): boolean => customerType === MONTHLY_CUSTOMER_TYPE;

export const isMeteredCustomerType = (customerType?: string | null): boolean =>
  !!customerType && (METERED_CUSTOMER_TYPES as readonly string[]).includes(customerType);

/**
 * 下訂流程要不要出現「付款方式」那一步。
 *
 * 三個條件都成立才顯示：瓦斯行有開電子付款、客戶不是月結、客戶不是走表。
 * 任一不成立就跳過，配送時間直接進確認訂單頁，付款方式由後端依客戶類型推導。
 */
export const shouldShowPaymentStep = (input: { allowElectronicPay: boolean; isMonthlyCustomer: boolean; isMeteredCustomer: boolean }): boolean =>
  input.allowElectronicPay && !input.isMonthlyCustomer && !input.isMeteredCustomer;
